<template>
  <div class="component hb-gap" :style="gapStyle">
    <slot></slot>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    config: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      defaultConfig: {
        background: '',
        height: 1,
        border: 'none'
      },
      gapStyle: ''
    }
  },
  computed: {},
  watch: {},
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {
    this.init()
  },
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {
    init () {
      Object.assign(this.defaultConfig, this.config)
      this.gapStyle = `background: ${this.defaultConfig.background};height: ${this.defaultConfig.height}px;border: ${this.defaultConfig.border}`
    }
  }
}
</script>

<style lang='scss' scoped>
.component.hb-gap {}
</style>
